// =============================================================================
// app.js — Global entry point for simplybook.me (public site)
//
// Loaded on every public page via encore_entry_script_tags('app') in main.html.twig.
// Provides: jQuery ($), global singletons (Login, Feedback, _t, rudderstack),
// core UI components, analytics, and page-level interaction handlers.
//
// Per-page JS lives in assets/js/pages/. Heavy modules are lazy-loaded via
// assets/js/components/lazyInitializer.js (sliders, etc.)
// =============================================================================


// ─────────────────────────────────────────────────────────────────────────────
// IMPORTS — side-effect (no export used)
// ─────────────────────────────────────────────────────────────────────────────

// @disabled — quik_scroll mobile scroll indicator, disabled
// require('./quickMobileScroll');
require('./components/ui-components/modal-bootstrap-v3.4.1');
require('./components/ui-components/animateOnScoroll');
require('./components/ui-components/scrollSnapArm');


// ─────────────────────────────────────────────────────────────────────────────
// IMPORTS — named modules
// ─────────────────────────────────────────────────────────────────────────────

const TooltipPositioning = require('./components/ui-components/tooltip.js').TooltipPositioning;
const simpleAccordion = require('./components/ui-components/simpleAccordion').simpleAccordion;
const lazyImages = require('./components/ui-components/LazyLoad.js').lazyImages;
const videoPopup = require('./components/ui-components/VideoPopup').videoPopup;
const copyPrompt = require('./components/ui-components/copyPrompt').copyPrompt;

const {onModeEnter, onModeLeave, getMode} = require('./media.js');
const StickyHeader = require('./StickyHeader.js').StickyHeader;
const StickyTabs = require('./StickyHeader.js').StickyTabs;
const FooterAccordion = require('./FooterAccordion.js').FooterAccordion;
const Icons = require('./Icons.js').Icons;
const effects = require('./effects.js');

const debug = require('./debug.js');
const support = require('./support.js');
const $ = require("jquery");
const Login = require('./login/login').Login;
const { initSimpleTabs } = require("./components/ui-components/tab");
const rudderstack = require('./analytics/rudderstack/rudderstack.js').rudderstack;
const { initRudderstackAnalytics } = require('./analytics/rudderstack/events.js');
import { initEagerComponents, initLazyComponents } from './components/lazyInitializer';

// @disabled — nail-salon tab, no longer used globally
// const nailTab = require('./nail-salon-lending/tab.js');

// @disabled — caused errors on unrelated pages; under investigation
// const schedulingSoftwarePage = require('./scheduling-software/main.js');

// @deprecated — Registration removed from global bundle; kept commented for reference
// global.Registration = require('./registration/registration').Registration;


// ─────────────────────────────────────────────────────────────────────────────
// GLOBALS — singletons exposed to Twig-rendered inline scripts and page JS
// ─────────────────────────────────────────────────────────────────────────────

global.Login = Login;
global.Feedback = require('./feedback/feedback').Feedback;
global._t = _t;
global.rudderstack = rudderstack;
// jQuery's dist build suppresses window.$/window.jQuery when bundled (CommonJS noGlobal
// guard) — restore it, since inline <script> blocks in Twig layouts rely on the global.
global.$ = global.jQuery = $;


// ─────────────────────────────────────────────────────────────────────────────
// UTILITY FUNCTIONS
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Runs callback during browser idle time (or after `timeout` ms fallback).
 * Used to defer non-critical work past LCP/TBT measurement window.
 */
function runWhenIdle(cb, timeout) {
	var t = (typeof timeout === 'number') ? timeout : 1200;
	if (window.requestIdleCallback) window.requestIdleCallback(function () { cb(); }, { timeout: t });
	else setTimeout(cb, 1);
}


// ─────────────────────────────────────────────────────────────────────────────
// CORE UI — immediate initialization on every page
// ─────────────────────────────────────────────────────────────────────────────

initEagerComponents();
initLazyComponents();

new StickyHeader();
new StickyTabs();
new FooterAccordion();
new Icons();
if ($('.templates__slider, .section--reviews-carousel, .reviews--slider-v2').length) {
    Promise.all([
        import(/* webpackChunkName: "slick-sliders" */ './TemplatesSlider.js'),
        import(/* webpackChunkName: "slick-sliders" */ './ReviewsSlider.js'),
    ]).then(function(mods) {
        var TemplatesSlider = mods[0].TemplatesSlider;
        var ReviewsSlider   = mods[1].ReviewsSlider;
        var ReviewsSlider_v2 = mods[1].ReviewsSlider_v2;
        if ($('.templates__slider').length) new TemplatesSlider();
        if ($('.section--reviews-carousel').length) new ReviewsSlider();
        if ($('.reviews--slider-v2').length) new ReviewsSlider_v2();
    });
}
new simpleAccordion();

// Handle lazy loading images
lazyImages();
// Handle lazy loading youtube video in popups
videoPopup();
// Copy-to-clipboard for the Ask Simply starter prompts
copyPrompt();

// Rudderstack Analytics tracking
initRudderstackAnalytics();

support.supportChat();
new TooltipPositioning();

effects.addRippleToButton($('.btn, li.to-previous-step'));

// Dev-only screen-size logger — deferred to idle time, doesn't need to run
// before LCP/TBT are measured.
runWhenIdle(function () { debug.showScreenSize(); });

// Deferred backdrop-filter: apply 500ms after window.load so GPU compositing layers
// are not created during FCP/LCP/TBT measurement window.
window.addEventListener('load', function () {
	setTimeout(function () {
		document.body.classList.add('is-page-ready');
	}, 500);
}, { once: true, passive: true });


// ─────────────────────────────────────────────────────────────────────────────
// MOBILE NAVIGATION — header menu toggle
// ─────────────────────────────────────────────────────────────────────────────

var menuWasOpen = false;

$('.header--togg-menu').click(function () {
    menuWasOpen = !menuWasOpen;
    closeMenu();
});

$('.morph-shape, .header--mob-togg-menu, .sb-header--profile-toggler').click(function () {
    menuWasOpen = false;
    closeMenu();
});

initSimpleTabs($('.tab-switcher--header:not(.developer-tab-switch):not(.team-tab-switch)'));


function closeMenu() {
    if (menuWasOpen) {
        $('body').addClass('menu--opened');
        $('.header--togg-menu, .header .morph-shape').addClass('open');
		$('.main-nav').addClass('open');
    } else {
        $('body').removeClass('menu--opened');
        $('.main-nav').removeClass('open');
        $('.main-nav .menu--link-has-dropdown .submenu').removeClass('opened');
		$('.header--togg-menu, .morph-shape').removeClass('open');
    }
}

$(window).resize(function () {
    // g_heightHeader = $('.header .header--settings-block .header--settings-container').height();
    // g_windowHeight = $(window).height() - g_heightHeader;
    // g_windowHeightThird = (g_windowHeight / 3);
    // g_windowWidth = $(window).width();
    //setHeightForCategoryItem();

    if ($(window).width() > 768) {
        menuWasOpen = false;
        closeMenu();
    }
});



// ─────────────────────────────────────────────────────────────────────────────
// HEADER ACCORDION RELOCATION — moves accordion items on mobile
//
// On < 768px: moves accordion panels adjacent to their trigger links.
// On >= 768px: moves them back into the main .accordion container.
// ─────────────────────────────────────────────────────────────────────────────

(function() {
	const BREAKPOINT = 768; // 🔹

	function relocateAccordionItems() {
		const accordionContainer = document.querySelector('.sb-header .accordion');
		const headerItems = document.querySelectorAll('.accordion-header__item [data-accordion]');
		if (!accordionContainer || !headerItems.length) return;

		if (window.innerWidth < BREAKPOINT) {
			headerItems.forEach(link => {
				const targetId = link.getAttribute('data-accordion');
				const targetBlock = document.querySelector(targetId);
				if (!targetBlock) return;

				const parentItem = link.closest('.accordion-header__item');
				const next = parentItem.nextElementSibling;
				if (!next || !next.isSameNode(targetBlock)) {
					parentItem.after(targetBlock);
				}
			});
		} else {
			const allItems = document.querySelectorAll('.sb-header .accordion-item');
			allItems.forEach(item => {
				if (!accordionContainer.contains(item)) {
					accordionContainer.appendChild(item);
				}
			});
		}
	}

	// Виклик при завантаженні
	document.addEventListener('DOMContentLoaded', relocateAccordionItems);

	// Виклик при ресайзі (debounce щоб не смикати часто)
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(relocateAccordionItems, 150);
	});

	// MutationObserver: якщо довантажили HTML пізніше
	// Guard prevents cascading reflows: DOM moves inside relocateAccordionItems()
	// would re-trigger the observer, causing window.innerWidth reads after each write.
	let relocating = false;
	const observer = new MutationObserver(() => {
		if (relocating) return;
		relocating = true;
		relocateAccordionItems();
		relocating = false;
	});
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
})();


// ─────────────────────────────────────────────────────────────────────────────
// REVIEW ACCORDION — expand/collapse long review text inside the slider
// ─────────────────────────────────────────────────────────────────────────────

function reviewAccordion() {
	const slider = $('.reviews--slider');

	// авто-ID
	slider.find('.short-review').each(function (index) {
		const id = 'review-text-' + (index + 1);
		$(this).attr('id', id);
		$(this).find('.read-more').attr('aria-controls', id);
	});

	slider.on('click keydown', '.read-more', function (e) {
		if (e.type === 'keydown' && !(e.key === 'Enter' || e.key === ' ')) return;

		const btn = $(this);
		const review = btn.closest('.short-review');
		const isOpen = btn.hasClass('open');
		const sliderEl = $('.reviews--slider');

		e.preventDefault();

		// aria
		btn.attr('aria-expanded', !isOpen);

		// toggle UI
		btn.toggleClass('open');
		review.toggleClass('full-review');

		// close others
		slider.find('.read-more').not(btn)
			.removeClass('open')
			.attr('aria-expanded', 'false');

		slider.find('.short-review').not(review)
			.removeClass('full-review')
			.css('max-height', 76);

		// expand
		if (review.hasClass('full-review')) {
			review.animate({'max-height': review[0].scrollHeight + "px"}, {
				duration: 300,
				step: function () {
					sliderEl.slick('resize');
					sliderEl.slick("setOption", null, null, true);
				}
			});
		} else {
			review.animate({'max-height': 76}, {
				duration: 200,
				step: function () {
					sliderEl.slick('resize');
					sliderEl.slick("setOption", null, null, true);
				}
			});
		}

		// додаткові хелпери — важливо
		setTimeout(resizeReviewsCarousel, 50);
		setTimeout(resizeReviewsCarousel, 150);
		setTimeout(resizeReviewsCarousel, 350);

		function resizeReviewsCarousel() {
			sliderEl.slick('resize');
			sliderEl.find(".slick-slide").css("height", "auto");
			sliderEl.find(".slick-list").css("height", "auto");
		}
	});
}

reviewAccordion();

function openSubMenuOnTuch() {
    $('.header--navigation-menu-container').on('click', '.header--main-nav-mobile .menu--link-has-dropdown', function () {
        var get_data = $(this).data("submenu");
        var sub_menu = $(this).closest('.header--main-nav-mobile .main-nav--menu').find('#' + get_data);
        $(sub_menu).addClass('opened');
    });
}

openSubMenuOnTuch();

function goToPrevMenuOnTuch() {
    $('.header--navigation-menu-container ').on('click', '.header--main-nav-mobile .submenu .to-previous-step', function (e) {
        $('.submenu').removeClass('opened');
        e.stopPropagation();
    })
}

goToPrevMenuOnTuch();


// ─────────────────────────────────────────────────────────────────────────────
// ANCHOR SCROLL & SECTION HIGHLIGHTING
//
// Handles smooth scroll on .anchor-link clicks with correct offset for the
// sticky header.
// ─────────────────────────────────────────────────────────────────────────────

function smoothScrollAnchorLinks() {
    $('.anchor-link').click(function (e) {
        e.preventDefault();
        $('.anchor-link').removeClass('active');

        var target = $($(this).attr('href'));
        if (!target.length) return;

        var offset_value = $(this).data('offset') || 0;
        if (getMode() != 'desktop') offset_value = offset_value - $(this).height();
        if (getMode() == 'mob') offset_value = 0;

        var scrollTo = target.offset().top - (offset_value > 0 ? offset_value : 0);
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var duration = prefersReduced ? 0 : 800;

        var scrollDone = false;
        $('body, html').stop().animate({scrollTop: scrollTo}, duration, function () {
            if (scrollDone) return;
            scrollDone = true;

            var targetEl = target[0];
            var focusable = target
                .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
                .filter(':visible')
                .first();

            if (focusable.length) {
                focusable[0].focus({preventScroll: true});
            } else {
                if (!targetEl.hasAttribute('tabindex')) {
                    targetEl.setAttribute('tabindex', '-1');
                }
                targetEl.focus({preventScroll: true});
            }
        });
    });
}

smoothScrollAnchorLinks();


// ─────────────────────────────────────────────────────────────────────────────
// SCROLL-BASED VISIBILITY UTILITY
//
// Tracks whether an element is in the viewport and fires a callback on enter/leave.
// ─────────────────────────────────────────────────────────────────────────────

function scrollToBlock(cur_block, callback, additionalOffset) {
    if ($(cur_block).length == 0) {
        return;
    }

    var isIn = checkIsIN();

    var additionalOffsetValue = additionalOffset;

    if (callback) callback(isIn);

    function checkIsIN() {
            var hT = cur_block.offset().top,
                hH = cur_block.outerHeight(),
                wH = $(window).height(),
                wS;

            if (additionalOffsetValue) {
                wS = $(window).scrollTop() + additionalOffsetValue;
            } else {
                wS = $(window).scrollTop();
            }


                return wS > (hT + hH - wH) && (hT > wS) && (wS + wH > hT + hH);
    }

    document.addEventListener('scroll', function () {
        if (checkIsIN()) {
            //console.log('in view');
            cur_block.addClass('in');
            if (!isIn) {
                if (callback) callback(true);
                isIn = true;
            }

        } else {
            //console.log('not in view');
            cur_block.removeClass('in');
            if (isIn) {
                if (callback) callback(false);
                isIn = false;
            }
        }
    }, {passive: true});
}

// Shared across covid / vaccination-schedule / features-integrations pages —
// cheap guarded no-op everywhere else, not worth a dedicated per-page entry.
scrollToBlock($('#letter-block'));

// @deprecated — number counter via scrollToBlock + jQuery.animate, replaced by
// the IntersectionObserver-based initNumberCounters() below.

function initNumberCounters() {
	const counters = document.querySelectorAll('.count-value');
	if (!counters.length) return;

	const animateValue = (el, start, end, duration, decimals, suffix = '') => {
		const startTime = performance.now();

		const tick = (now) => {
			const progress = Math.min((now - startTime) / duration, 1);
			const value = start + (end - start) * progress;
			el.textContent = value.toFixed(decimals) + suffix;

			if (progress < 1) {
				requestAnimationFrame(tick);
			}
		};

		requestAnimationFrame(tick);
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			const el = entry.target;
			const dataVal = el.dataset.val;
			if (!dataVal) return;

			const hasPercent = dataVal.includes('%');
			const cleanVal = parseFloat(dataVal.replace(/[,%]/g, '')) || 0;
			const decimals = (cleanVal.toString().split('.')[1] || '').length;
			const suffix = hasPercent ? '%' : '';

			if (entry.isIntersecting) {
				// запустити анімацію
				animateValue(el, 0, cleanVal, 2600, decimals, suffix);
			} else {
				// скинути, щоб при повторній появі знову стартував
				el.textContent = '0' + suffix;
			}
		});
	}, { threshold: 0.17 });

	counters.forEach(el => observer.observe(el));
}


initNumberCounters();

// @moved — integrations page hero-section nav visibility now lives in
// assets/js/pages/integrationsPage.js (only that page has #hero-section /
// .integrations__fixed-nav).


// ─────────────────────────────────────────────────────────────────────────────
// SCROLL TO TOP BUTTON
// ─────────────────────────────────────────────────────────────────────────────

document.addEventListener('scroll', function () {
    if ($(window).scrollTop() >= 200) {
        $('#scroll-to-top').addClass('in');
    } else {
        $('#scroll-to-top').removeClass('in');
    }
}, {passive: true});

$('#scroll-to-top').click(function (e) {
    e.preventDefault();
    $('body,html').animate({
        scrollTop: 0
    }, 500);
});

function _t(key, options) {
    let debugLang = true;
    let str = key;
    if ((typeof LANG != 'undefined') && LANG[key]) {
        str = LANG[key];
    } else if (debugLang) {
        console.warn('Lang key missing', key);
    }

    if (options !== undefined) {
        for (let k in options) {
            if (options.hasOwnProperty(k)) {
                let v = options[k];
                str = (str + '').replace('%' + k + '%', v);
            }
        }
    }

    return str;
}

if (getMode() == 'tablet' || getMode() == 'desktop' ) {
    scrollToBlock($('#covid-letter-block'), '', 150);
}

// Theme selection persistence — write side. #templates lives on the OLD homepage
// template (index-page/templates.html.twig, rendered when $newIndexEnabled is
// false), so this stays global. The read side (auto-scroll + activate on arrival)
// only matters on the booking-templates page — see initBookingTemplatesScripts.js.
let themesList = $('#templates .templates-list__item .btn--select-theme')
if( $(themesList).length ){
    themesList.on('click', function () {
        var selectedThemeName = $(this).data('theme-id');
        //console.log('rewrite input val');
        localStorage.setItem('selectedTheme', selectedThemeName );
    })
}

// ─────────────────────────────────────────────────────────────────────────────
// EXIT POPUP — suppress after user dismisses it
// ─────────────────────────────────────────────────────────────────────────────

$('#sb_ExitPopup').on('hidden.bs.modal', function () {
    localStorage.setItem('sm_popup_banner', '1');
});

// @deprecated — mouse-leave exit intent popup, disabled due to poor UX metrics


// ─────────────────────────────────────────────────────────────────────────────
// ENTERPRISE WIDGET TRIGGER — proxy click from .widget_btn to #sb_enterprise_widget
// ─────────────────────────────────────────────────────────────────────────────

if($(".widget_btn").length){
    $(".widget_btn").click(function(){
        $("#sb_enterprise_widget").trigger("click");
    });
}


// ─────────────────────────────────────────────────────────────────────────────
// DOM-READY COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

$(document).ready(function() {

    // Dev environment cookie banner suppression (local dev URLs only)
    if (window.location.href.indexOf("igor.d") > -1 || window.location.href.indexOf("memosh.dev18") > -1) {
        //$('.sb-important').fadeOut();
    }

	function faqAccordionInit() {
		const toggles = document.querySelectorAll('.masonry-grid--item-toggler');
		toggles.forEach(toggle => {
			const controlledId = toggle.getAttribute('aria-controls');
			const content = document.getElementById(controlledId);

			// Plain max-height transition (mirrors accordion.js) instead of jQuery
			// slideDown/slideUp, so opening/closing never depends on jQuery's own
			// reflow timing interacting with content-visibility/beforematch.
			// `instant` skips the height animation and jumps straight to the fully-open
			// state — used for the beforematch/Find-in-Page reveal path, where the browser
			// calls its own scrollIntoView() synchronously right after the handler returns;
			// an animation still in flight at that point scrolls to a layout that's about
			// to change underneath it (landing short, or cropped under the sticky header).
			const openFAQ = (instant = false) => {
				if (content.classList.contains('expanded')) return;
				toggle.setAttribute('aria-expanded', 'true');
				toggle.classList.add('--active');
				content.removeAttribute('hidden');
				content.setAttribute('aria-hidden', 'false');
				content.classList.add('expanded');
				if (instant) {
					content.style.maxHeight = 'none';
				} else {
					requestAnimationFrame(() => {
						if (content.classList.contains('expanded')) {
							content.style.maxHeight = content.scrollHeight + 'px';
						}
					});
				}
			};

			const closeFAQ = () => {
				if (!content.classList.contains('expanded')) return;
				const collapse = () => {
					content.classList.remove('expanded');
					content.style.maxHeight = '0px';
				};
				// A fully-open panel has max-height released to "none" (see the transitionend
				// listener below) — CSS can't transition away from "none", so restore the exact
				// pixel height first (while .expanded/padding is still applied). A single rAF
				// after that still lands in the same unpainted frame as this synchronous write,
				// so a second rAF is needed to force a real paint of the restored height first —
				// otherwise the collapse to 0 is an unanimatable jump instead of a transition.
				if (content.style.maxHeight === 'none') {
					content.style.maxHeight = content.scrollHeight + 'px';
					requestAnimationFrame(() => requestAnimationFrame(collapse));
				} else {
					requestAnimationFrame(collapse);
				}
				toggle.setAttribute('aria-expanded', 'false');
				toggle.classList.remove('--active');
				content.setAttribute('aria-hidden', 'true');
				content.setAttribute('hidden', 'until-found');
			};

			const toggleFAQ = () => {
				if (content.classList.contains('expanded')) {
					closeFAQ();
				} else {
					openFAQ();
				}
			};

			toggle.addEventListener('click', e => {
				e.preventDefault();
				toggleFAQ();
			});

			toggle.addEventListener('keydown', e => {
				if (['Enter', ' '].includes(e.key)) {
					e.preventDefault();
					toggleFAQ();
				}
			});

			// Browser find-in-page reveals hidden="until-found" content on its own;
			// this just syncs our aria/--active state and reveals it instantly (see openFAQ).
			content.addEventListener('beforematch', () => openFAQ(true));

			// Once the open transition finishes, release the height cap entirely so later
			// content/viewport changes are never clipped by a stale (or guessed) max-height.
			content.addEventListener('transitionend', e => {
				if (e.propertyName === 'max-height' && content.classList.contains('expanded')) {
					content.style.maxHeight = 'none';
				}
			});

			const header = toggle.closest('.masonry-grid--item-header');
			if (header) {
				header.addEventListener('click', e => {
					if (!toggle.contains(e.target)) {
						e.preventDefault();
						toggleFAQ();
					}
				});
			}
		});
	}
	faqAccordionInit();

	function toggleKeyBenefitsView() {
		const $section = $('.key-benefits.collapsible');

		if ($section.length ) {
			const $items = $section.find('.key-benefits__col');
			const $toggler = $section.find('.key-benefits__col-toggler');
			const $toggleBtn = $toggler.find('.toggle-view-items');
			const itemsToShowInitially = 2;

			if ($items.length > itemsToShowInitially) {
				// Show only first N items
				$items.each(function (index) {
					$items.each(function (index) {
						if (index <= itemsToShowInitially) {
							$(this).addClass('key-benefits__col--visible');
						} else {
							$(this).hide().addClass('key-benefits__col--hidden');
						}
					});
				});

				// Show the toggle block
				$toggler.removeClass('hidden');

				// Handle toggle click
				$toggleBtn.on('click', function () {
					const isExpanded = $section.hasClass('key-benefits--expanded');

					$(this).toggleClass('expanded');

					if (isExpanded) {
						// Collapse view - hide extras
						$items.each(function (index) {
							if (index > itemsToShowInitially) {
								$(this).slideUp();
							}
						});
						$section.removeClass('key-benefits--expanded');
					} else {
						// Expand view - show all
						$items.slideDown();
						$section.addClass('key-benefits--expanded');
					}
				});
			}
		}
	}

	toggleKeyBenefitsView();

});



/**
 * Waits until selector appears in DOM, then runs callback ONCE.
 * Works for SSR, delayed Twig includes, React mounts, etc.
 */
function runWhenReady(selector, callback, options = {}) {
	const { once = true, maxWait = 4000 } = options;
	if (document.querySelector(selector)) {
		callback();
		return;
	}

	let done = false;
	const observer = new MutationObserver(() => {
		if (done) return;
		if (document.querySelector(selector)) {
			if (once) done = true;
			observer.disconnect();
			callback();
		}
	});

	observer.observe(document.body, { childList: true, subtree: true });

	// optional timeout safeguard
	setTimeout(() => {
		if (!done && document.querySelector(selector)) {
			callback();
			observer.disconnect();
		}
	}, maxWait);
}

/**
 * Safe DOM ready
 */
function onDOMReady(fn) {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', fn);
	} else {
		fn();
	}
}

// ─────────────────────────────────────────────────────────────────────────────
// ACCESSIBILITY COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

// Tooltip keyboard navigation
function tooltipKeyboardNav() {
	const tooltips = document.querySelectorAll('.tooltip-component');
	if (!tooltips.length) return;

	tooltips.forEach(el => {
		el.setAttribute('tabindex', '0'); // allow keyboard focus if not button
		el.addEventListener('keydown', e => {
			if (['Enter', ' '].includes(e.key)) {
				e.preventDefault();
				el.classList.toggle('is-active');
			}
		});
		el.addEventListener('focus', () => el.classList.add('is-active'));
		el.addEventListener('blur', () => el.classList.remove('is-active'));
		el.addEventListener('mouseleave', () => el.classList.remove('is-active'));
	});
}

/**
 * Unified dropdown control — supports hover, click and keyboard navigation
 * Keeps state consistent across input methods (mouse/keyboard)
 */
function mainMenuDropdownKeyboardNav() {
	const dropdowns = document.querySelectorAll('.dropdown');
	if (!dropdowns.length) return;

	// console.log(dropdowns) // P0-1: removed debug log

	dropdowns.forEach(dropdown => {
		const toggle = dropdown.querySelector('.dropdown-toggle, [data-dropdown]');
		const menu = dropdown.querySelector('.dropdown-menu');
		if (!toggle || !menu) return;

		const items = menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
		let isOpen = false;
		let isMouseInside = false;

		/** Opens the dropdown */
		const openMenu = () => {
			if (isOpen) return;
			menu.classList.add('is-visible');
			toggle.setAttribute('aria-expanded', 'true');
			isOpen = true;
			items.forEach(el => el.setAttribute('tabindex', '0'));
		};

		/** Closes the dropdown */
		const closeMenu = () => {
			if (!isOpen) return;
			menu.classList.remove('is-visible');
			toggle.setAttribute('aria-expanded', 'false');
			isOpen = false;
			items.forEach(el => el.setAttribute('tabindex', '-1'));
		};

		/** Toggle click (works for both <a> and <button>) */
		toggle.addEventListener('click', e => {
			// Prevent accidental navigation when closed
			if (!isOpen && toggle.tagName.toLowerCase() === 'a') e.preventDefault();
			isOpen ? closeMenu() : openMenu();
		});

		/** Keyboard control on toggle */
		toggle.addEventListener('keydown', e => {
			if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
				e.preventDefault();
				openMenu();
				setTimeout(() => {
					if (e.key === 'ArrowUp') items[items.length - 1]?.focus();
					else items[0]?.focus();
				}, 80);
			}
		});

		/** Keyboard navigation inside dropdown */
		menu.addEventListener('keydown', e => {
			const list = Array.from(items);
			const i = list.indexOf(document.activeElement);
			switch (e.key) {
				case 'ArrowDown':
					e.preventDefault();
					list[(i + 1) % list.length]?.focus();
					break;
				case 'ArrowUp':
					e.preventDefault();
					list[(i - 1 + list.length) % list.length]?.focus();
					break;
				case 'Home':
					e.preventDefault();
					list[0]?.focus();
					break;
				case 'End':
					e.preventDefault();
					list[list.length - 1]?.focus();
					break;
				case 'Escape':
					e.preventDefault();
					closeMenu();
					toggle.focus();
					break;
			}
		});

		/** Hover open/close (synced with keyboard state) */
		dropdown.addEventListener('mouseenter', () => {
			isMouseInside = true;
			openMenu();
		});
		dropdown.addEventListener('mouseleave', () => {
			isMouseInside = false;
			setTimeout(() => {
				if (!isMouseInside && !dropdown.contains(document.activeElement)) closeMenu();
			}, 120);
		});

		/** Close on outside click */
		document.addEventListener('click', e => {
			if (!dropdown.contains(e.target)) closeMenu();
		});

		/** Close when focus truly leaves dropdown (fixes premature close on Tab) */
		dropdown.addEventListener('focusout', function (e) {
			// wait a tick so the next focused element is known
			setTimeout(function () {
				if (!dropdown.contains(document.activeElement) && !isMouseInside) {
					closeMenu();
				}
			}, 100);
		});

		// Remove from tab order initially
		items.forEach(el => el.setAttribute('tabindex', '-1'));
	});
}
/**
 * Mirrors the compare-table--embed.html.twig horizontal scroll in the thin bar
 * underneath it. Purely an indicator: aria-hidden, not draggable. Shared across
 * every page using the component so no per-page JS entry is needed (CY1SDEV1-4410).
 */
function compareTableScrollIndicator() {
	document.querySelectorAll('[data-compare-scroll]').forEach(scroller => {
		const wrapper = scroller.closest('.compare-table-v2');
		const track = wrapper && wrapper.querySelector('[data-compare-indicator]');
		const thumb = wrapper && wrapper.querySelector('[data-compare-thumb]');

		function update() {
			const scrollable = scroller.scrollWidth - scroller.clientWidth;

			// Drives the pinned feature column's edge shadow (CY1SDEV1-4410
			// follow-up): only a real affordance when there's something to
			// scroll to, e.g. not on setmore-alternative where the table now
			// fills its container exactly.
			if (wrapper) {
				wrapper.classList.toggle('is-scrollable', scrollable > 0);
			}

			if (!track || !thumb) return;
			if (scrollable <= 0) {
				track.style.visibility = 'hidden';
				return;
			}
			track.style.visibility = '';

			const ratio = scroller.clientWidth / scroller.scrollWidth;
			const thumbWidth = Math.max(ratio * 100, 10);
			thumb.style.width = thumbWidth + '%';
			thumb.style.transform =
				'translateX(' + (scroller.scrollLeft / scrollable) * ((100 - thumbWidth) / thumbWidth) * 100 + '%)';
		}

		scroller.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);
		update();
	});
}

onDOMReady(() => {
	// Register components to be initialized when ready
	runWhenReady('.tooltip-component', tooltipKeyboardNav);
	runWhenReady('.dropdown', mainMenuDropdownKeyboardNav);
	runWhenReady('[data-compare-scroll]', compareTableScrollIndicator);
});

